import Select from 'components/base/select';
import React, { FC } from 'react';
import { selectionTypeList } from 'utils/constants';
type Props = {
  selectionType: string;
  setSelectionType: (value: string) => void;
};
const SelectionType: FC<Props> = ({ selectionType, setSelectionType }) => {
  return (
    <div className='my-[28px]'>
      <p className='font-medium text-sm'>Add-on category selection type</p>
      <Select
        placeholder='Single Selection'
        value={selectionType}
        options={selectionTypeList}
        onChange={setSelectionType}
      />
    </div>
  );
};

export default SelectionType;
